import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { ToastConfig } from '../../interfaces/common';
import { AuthService } from '../../../pages/auth/services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class CommonService {
  private http: HttpClient = inject(HttpClient);
  private authService = inject(AuthService);
  private apiBaseUrl = environment.apiBaseUrl;

  private toastSubject = new Subject<ToastConfig>();
  toast$ = this.toastSubject.asObservable();

  private connectionNameSubject = new BehaviorSubject<string | null>(null);
  public connectionName$ = this.connectionNameSubject.asObservable();

  private userNameSubject = new BehaviorSubject<string | null>(null);
  public userName$ = this.userNameSubject.asObservable();

  triggerToast(config: ToastConfig) {
    this.toastSubject.next(config);
  }

  verifyEmail(email: string, captchaToken: string): Observable<boolean> {
    return this.http.post<boolean>(`${this.apiBaseUrl}/api/email/send-otp`, {
      email: email,
      recaptcha: captchaToken,
    });
  }

  public updateConnectionName(name: string) {
    this.authService.updateConnectionDisplayName(name);
    this.connectionNameSubject.next(name);
  }

  public updateUserName(name: string) {
    this.authService.updateUserName(name);
    this.userNameSubject.next(name);
  }
}
